import React from 'react';
import { Modal, Input, Form, Select } from 'antd';

const { Option } = Select;
const { Search } = Input;

class FormModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    handleChangeTipoDocumento = (option) => {
        this.props.form.setFieldsValue({
            numeroDocumento: '',
        }, () => {
            this.props.form.validateFields(["numeroDocumento"]);
            this.props.onChange("clear");
        });
    }

    handleCancel = () => {
        this.props.onClose();
        this.props.form.resetFields();
    }

    handleOk = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            console.log(values);
            if (!err) {
                const form = {
                    id: values.id,
                    idTipoDocumento: values.idTipoDocumento.key,
                    numeroDocumento: values.numeroDocumento,
                    razonSocial: values.razonSocial,
                    idCondicionSunat: values.idCondicionSunat.key,
                    idEstadoContribuyente: values.idEstadoContribuyente.key,
                    telefono: values.telefono,
                    direccion: values.direccion,
                    abreviatura: values.abreviatura,
                    idUbigeo: values.idUbigeo === undefined ? 0 : values.idUbigeo.key,
                    idPlanCuentaSoles: values.idPlanCuentaSoles === undefined ? 0 : values.idPlanCuentaSoles.key,
                    idPlanCuentaDolares: values.idPlanCuentaDolares === undefined ? 0 : values.idPlanCuentaDolares.key,

                }
                this.props.onSave(form, this.props.form);
            }
        });
    }

    render() {
        const { getFieldDecorator } = this.props.form;

        getFieldDecorator('id', { initialValue: this.props.formValues.id });

        return (
            <Modal
                title={this.props.formValues.id === 0 ? "Registrar Banco" : "Modificar Banco"}
                visible={this.props.visible}
                cancelText={"Cancelar"}
                okText={"Guardar"}
                onCancel={this.handleCancel}
                onOk={this.handleOk}
                style={{ top: 30 }}
                width="800px"
            >
                <Form>
                    {getFieldDecorator('id', { initialValue: this.props.formValues.id })(
                        <input type="hidden" />
                    )}
                    <div className="row">
                        <div className="col-md-6 form-group">
                            <Form.Item label="Tipo de Documento">
                                {getFieldDecorator('idTipoDocumento', {
                                    initialValue: this.props.formValues.idTipoDocumento ?
                                        { key: this.props.formValues.idTipoDocumento } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.'
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione tipo de documento"}
                                        optionFilterProp="children"
                                        onChange={this.handleChangeTipoDocumento}
                                    >
                                        {this.props.formValues.tiposDocumento.map(item => (
                                            <Option key={item.id} value={item.id}>{item.abreviatura}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-6 form-group">
                            <Form.Item label="Número Documento">
                                {getFieldDecorator('numeroDocumento', {
                                    initialValue: this.props.formValues.numeroDocumento,
                                    rules: [
                                        {
                                            required: true,
                                            message: 'Campo obligatorio.',
                                            whitespace: true,
                                        },
                                        {
                                            length: 11,
                                            message: 'La longitud de ser de 11 caracteres.'
                                        }
                                    ]
                                })(
                                    <Search
                                        placeholder="Búsqueda por Documento"
                                        autoComplete="off"
                                        maxLength={11}
                                        loading={this.props.formValues.searchLoading}
                                        onSearch={value => this.props.onBuscarPadronReducido(this.props.form.getFieldValue('idTipoDocumento').key, value, this.props.form)}
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Form.Item label="Razón Social">
                                {getFieldDecorator('razonSocial', {
                                    initialValue: this.props.formValues.razonSocial,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                        whitespace: true
                                    }]
                                })(
                                    <Input
                                        placeholder="Ingresar Razón Social"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6 form-group">
                            <Form.Item label="Condición Sunat">
                                {getFieldDecorator('idCondicionSunat', {
                                    initialValue: this.props.formValues.idCondicionSunat ?
                                        { key: this.props.formValues.idCondicionSunat } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Condición Sunat"}
                                        optionFilterProp="children"
                                    >
                                        {this.props.formValues.condicionesSunat.map(item => (

                                            <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-6 form-group">
                            <Form.Item label="Estado Contribuyente">
                                {getFieldDecorator('idEstadoContribuyente', {
                                    initialValue: this.props.formValues.idEstadoContribuyente ?
                                        { key: this.props.formValues.idEstadoContribuyente } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Estado Contribuyente"}
                                        optionFilterProp="children"
                                    >
                                        {this.props.formValues.estadosContribuyente.map(item => (

                                            <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4 form-group">
                            <Form.Item label="Tipo Establecimiento">
                                {getFieldDecorator('nombreTipoEstablecimiento', {
                                    initialValue: this.props.formValues.nombreTipoEstablecimiento
                                })(
                                    <Input disabled autoComplete="off" />
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-4 form-group">
                            <Form.Item label="Teléfono">
                                {getFieldDecorator('telefono', {
                                    initialValue: this.props.formValues.telefono,
                                })(
                                    <Input
                                        placeholder="Ingresar Teléfono"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </div>

                        <div className="col-md-4 form-group">
                            <Form.Item label="Abreviatura">
                                {getFieldDecorator('abreviatura', {
                                    initialValue: this.props.formValues.abreviatura,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                        whitespace: true
                                    }]
                                })(
                                    <Input
                                        placeholder="Ingresar Abreviatura"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4 form-group">
                            <Form.Item label="Departamento">
                                {getFieldDecorator('idDepartamento', {
                                    initialValue: this.props.formValues.idDepartamento ?
                                        { key: this.props.formValues.idDepartamento } : undefined
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione departamento"}
                                        optionFilterProp="children"
                                        onChange={(option) => {
                                            this.props.form.setFieldsValue({ idProvincia: undefined });
                                            this.props.form.setFieldsValue({ idUbigeo: undefined });
                                            this.props.onChange("idDepartamento", option.key)
                                        }}
                                    >
                                        {this.props.formValues.departamentos.map(item => (
                                            <Option key={item.id} value={item.id} >{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-4 form-group">
                            <Form.Item label="Provincia">
                                {getFieldDecorator('idProvincia', {
                                    initialValue: this.props.formValues.idProvincia ?
                                        { key: this.props.formValues.idProvincia } : undefined
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione provincia"}
                                        optionFilterProp="children"
                                        onChange={(option) => {
                                            this.props.form.setFieldsValue({ idUbigeo: undefined });
                                            this.props.onChange("idProvincia", option.key)
                                        }}
                                    >
                                        {this.props.formValues.provincias.map(item => (
                                            <Option key={item.id} value={item.id} >{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-4 form-group">
                            <Form.Item label="Distrito">
                                {getFieldDecorator('idUbigeo', {
                                    initialValue: this.props.formValues.idUbigeo ?
                                        { key: this.props.formValues.idUbigeo } : undefined
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione distrito"}
                                        optionFilterProp="children"
                                    >
                                        {this.props.formValues.distritos.map(item => (
                                            <Option key={item.id} value={item.id} >{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Form.Item label="Dirección">
                                {getFieldDecorator('direccion', {
                                    initialValue: this.props.formValues.direccion
                                })(
                                    <Input
                                        placeholder="Ingresar Dirección"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6 form-group">
                            <Form.Item label="Cuenta Contable Soles">
                                {getFieldDecorator('idPlanCuentaSoles', {
                                    initialValue: this.props.formValues.idPlanCuentaSoles ?
                                        { key: this.props.formValues.idPlanCuentaSoles } : undefined,
                                    rules: [{
                                        required: false,
                                        message: 'Campo obligatorio.'
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Cuenta Contable Soles"}
                                        optionFilterProp="children"
                                    >
                                        {this.props.formValues.cuentasContables.map(item => (
                                            item.idMoneda == 1 ?
                                                <Option key={item.id} value={item.id}> {item.cuentaContable}-{item.nombre}</Option>
                                                : null
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-6 form-group">
                            <Form.Item label="Cuenta Contable Dólares">
                                {getFieldDecorator('idPlanCuentaDolares', {
                                    initialValue: this.props.formValues.idPlanCuentaDolares ?
                                        { key: this.props.formValues.idPlanCuentaDolares } : undefined,
                                    rules: [{
                                        required: false,
                                        message: 'Campo obligatorio.'
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Cuenta Contable Dólares"}
                                        optionFilterProp="children"
                                    >
                                        {this.props.formValues.cuentasContables.map(item => (
                                            item.idMoneda == 2 ?
                                                <Option key={item.id} value={item.id}> {item.cuentaContable}-{item.nombre}</Option>
                                                : null
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                    </div>
                </Form>
            </Modal>
        );
    }
}
export default Form.create()(FormModal)